module.exports = __webpack_public_path__ + "assets/img/teacher (39).f25d1f11.png";